import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { SearchContainer } from "app/pages/conversion/conversionTableContainer/StyledComponents";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const WebsiteAnalysisSubdomainsContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 100%;
    align-items: center;
`;

export const BoxContainer: any = styled(Box)`
    width: 100%;
    max-width: 1368px;
    height: auto;
    border-radius: 6px;
    overflow: hidden;
`;

export const TableTopContainer = styled(SearchContainer)<{ isCompare?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-top: ${({ isCompare }) => (isCompare ? `1px solid ${colorsPalettes.carbon[100]}` : "none")};

    .SearchInput-container {
        width: 100%;

        > div:first-child {
            top: 13px;
        }

        > .SearchInput {
            height: 48px;
        }
    }
`;

export const StyledTableTitle = styled(Text)`
    height: 63px;
    background-color: ${colorsPalettes.carbon[0]};
    padding: 20px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    display: block;
`;

export const ButtonContainer = styled.div`
    margin-right: 16px;

    .excel-button-wrapper {
        bottom: 0px;
    }
`;

export const GreyNotificationContainer = styled.div`
    background-color: ${colorsPalettes.bluegrey[200]};
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;
    border-radius: 4px;
    grid-row: 2;
    grid-column: 1 / span 2;
    margin: 0px 8px 8px;

    .SWReactIcons {
        margin-right: 0.75em;
    }
`;

export const FlexRowAlignCenter = styled(FlexRow)`
    align-items: center;
    padding: 12px;
    gap: 16px;

    [data-automation-icon-name="arrow"] svg {
        width: 10px;
        height: 5px;
    }
`;
